import { useState } from 'react';

export function useAcceptOrderDialog() {
    const [acceptOrderDialog, setAcceptOrderDialog] = useState();
    return {
        acceptOrderDialog,
        setAcceptOrderDialog,
    };
}
